import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import { api } from '../../utils/electronAPI';

export const getProjectsContent = createAsyncThunk(
    'projects/getProjectsContent',
    async (_, { rejectWithValue }) => {
        try {
            return await api.getProjects();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const projectSlice = createSlice({
    name: 'projects',
    initialState: { isLoading: false, projects: [], error: null },
    reducers: {
        addNewProject: (state, action) => {
            state.projects.push({ ...action.payload, is_deleted: 0, sort_index: state.projects.length });
        },
        updateProject: (state, action) => {
            const idx = state.projects.findIndex(p => p.id === action.payload.id);
            if (idx !== -1) state.projects[idx] = { ...state.projects[idx], ...action.payload };
        },
        deleteProject: (state, action) => {
            state.projects = state.projects.map(p =>
                p.id === action.payload.id ? { ...p, is_deleted: 1 } : p
            );
        },
        archiveProject: (state, action) => {
            state.projects = state.projects.map(p =>
                p.id === action.payload.id ? { ...p, is_archived: 1 } : p
            );
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProjectsContent.pending, (state) => { state.isLoading = true; })
            .addCase(getProjectsContent.fulfilled, (state, action) => {
                state.projects = (action.payload || []).sort((a, b) => (a.sort_index ?? 0) - (b.sort_index ?? 0));
                state.isLoading = false;
            })
            .addCase(getProjectsContent.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { addNewProject, updateProject, deleteProject, archiveProject } = projectSlice.actions;
export default projectSlice.reducer;

const selectAllProjects = state => state.projects?.projects || [];

const STATUS_ORDER = { aktiv: 0, geplant: 1, pausiert: 2, abgeschlossen: 3 };

export const selectActiveProjects = createSelector(
    [selectAllProjects],
    projects => projects
        .filter(p => p.is_deleted !== 1 && p.is_archived !== 1)
        .sort((a, b) => {
            const sa = STATUS_ORDER[a.status] ?? 1;
            const sb = STATUS_ORDER[b.status] ?? 1;
            if (sa !== sb) return sa - sb;
            // Within same status: newest first by created_at (most recently added on top)
            const da = new Date(a.created_at || a.start_date || 0).getTime();
            const db = new Date(b.created_at || b.start_date || 0).getTime();
            return db - da;
        })
);
